var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 124,
    viewBox: "0 0 99 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_6785)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8134 13.7794C47.3134 13.8747 47.8152 13.9784 48.3189 14.0903C48.7594 14.1882 49.1985 14.2918 49.6361 14.4011C75.1326 20.7681 95.6881 46.3306 96.47 72.5978C96.4777 72.856 96.4835 73.1143 96.4873 73.3727C96.4912 73.6301 96.4931 73.8876 96.4931 74.1451C96.4931 74.5963 96.4872 75.0448 96.4754 75.4905L46.8134 64.4545V13.7794ZM49.6361 62.1902V17.2938C73.5735 23.3126 92.866 47.3006 93.6459 71.9702L49.6361 62.1902Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0538 12.3553C49.5501 12.2434 49.0483 12.1398 48.5484 12.0444L46.8134 13.7794C47.3134 13.8747 47.8152 13.9784 48.3189 14.0903C48.7594 14.1882 49.1985 14.2918 49.6361 14.4011C75.1326 20.7681 95.6881 46.3306 96.47 72.5978C96.4777 72.856 96.4835 73.1143 96.4873 73.3727C96.4912 73.6301 96.4931 73.8876 96.4931 74.1451C96.4931 74.5963 96.4872 75.0448 96.4754 75.4905L98.2104 73.7556C98.2221 73.3099 98.228 72.8614 98.228 72.4101C98.228 71.8942 98.2203 71.3784 98.205 70.8628C97.4231 44.5956 76.8676 19.0332 51.3711 12.6662C50.9334 12.5569 50.4943 12.4532 50.0538 12.3553Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6361 17.2938V62.1902L93.6459 71.9702C92.866 47.3006 73.5735 23.3126 49.6361 17.2938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0538 102.379C28.1247 97.5062 10.3477 75.3451 10.3477 52.881C10.3477 32.5288 24.9395 18.9104 43.9907 20.1538C44.5651 20.1913 45.1435 20.2423 45.7257 20.307V17.3994C24.2706 14.8531 7.52498 29.6895 7.52498 52.2538C7.52498 76.3147 26.5658 100.051 50.0538 105.271C72.1451 110.18 90.3023 96.9605 92.3837 75.3522L89.5467 74.7218C89.4746 75.4182 89.3846 76.1052 89.2771 76.7824C86.2962 95.5622 69.8703 106.783 50.0538 102.379Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3189 104.114C26.3898 99.2411 8.61275 77.08 8.61275 54.616C8.61275 33.6502 24.0976 19.8304 43.9907 22.0419V20.1538V19.1343C22.5356 16.588 5.79004 31.4245 5.79004 53.9887C5.79004 78.0497 24.8308 101.786 48.3189 107.006C70.4101 111.915 88.5674 98.6955 90.6488 77.0872L89.2771 76.7824L87.8118 76.4567C85.7414 96.4676 68.8499 108.677 48.3189 104.114Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7257 20.307C45.1435 20.2423 44.5651 20.1913 43.9907 20.1538V22.0419L45.7257 20.307Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2771 76.7824C89.3846 76.1052 89.4746 75.4182 89.5467 74.7218L87.8118 76.4567L89.2771 76.7824Z",
    fill: "#4A0B82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_6785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.514,
    height: 101.264,
    fill: "white",
    transform: "matrix(0.976187 0.21693 0 1 0.144592 0.819336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.7cf2cab662b31c26aff27fa3f79cf76f.svg";
export { ForwardRef as ReactComponent };